import abstractSeqPromiseChain from "abstract-sequential-promise-chain";

function injectScript(url) {
	return new Promise((resolve, _) => {
		const script = document.createElement("script");

		script.src = url;
		script.async = true;
		script.onload = resolve.bind(this);
	
		document.body.appendChild(script);
	});
}


export default abstractSeqPromiseChain(injectScript)

export const lowPriorityScripts = abstractSeqPromiseChain(injectScript)